import { useMutation, UseMutationResult } from 'react-query';

import { getTokenWithType } from './useAuth';

import { getProcedureReference } from 'utils/urls';

import { ErrorModal } from 'types/modalTypes';

export async function fetchReferenceForProcedures({
  accountId,
  procedureIds,
  isRemove,
}: TVariables): Promise<TResult> {
  const response = await fetch(getProcedureReference(accountId), {
    method: 'PUT',
    headers: {
      Authorization: getTokenWithType(),
      'content-type': 'application/json',
    },
    body: JSON.stringify({
      ProcedureIds: procedureIds,
      IsRemoving: isRemove,
    }),
  });
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: Array<string> | [];
  IsSuccess: boolean;
  StatusCode: number;
} & ErrorModal;

type TVariables = {
  procedureIds: Array<number>;
  isRemove: boolean;
  accountId: number;
};

type TSnapshot = unknown;

function useProcedureReferences(): UseMutationResult<
  TResult,
  TError,
  TVariables,
  TSnapshot
> {
  return useMutation(async (params: TVariables) => {
    const fetchResponse = await fetchReferenceForProcedures(params);
    if (fetchResponse.Errors) throw fetchResponse;
    else if (fetchResponse) return fetchResponse;
    return fetchResponse;
  });
}

export { useProcedureReferences };
